import { Controller } from '@hotwired/stimulus';
import { useDebounce, useMutation } from 'stimulus-use';

export default class extends Controller {
  static targets = ['form', 'suggestions'];
  static values = { searchUrl: String };
  static debounces = [
    { name: 'suggest', wait: 300 },
    { name: 'mutate', wait: 50 },
  ];

  connect() {
    useDebounce(this);

    // We need to manually keep track of aria-busy changes to the suggestions
    // target because the frame sits inside the form and cannot be directly used
    // to show/hide the icons via CSS. Therefore, we mark the panel as busy if
    // anything inside it is busy.
    useMutation(this, {
      attributeFilter: ['aria-busy'],
      subtree: true,
    });
  }

  reset() {
    this.formTarget.removeAttribute('aria-busy');
    this.formTarget.reset();
    this.suggestionsTarget.src = this.#buildSearchUrl();
  }

  suggest() {
    const url = this.#buildSearchUrl(this.formTarget.q.value);
    this.suggestionsTarget.src = url;
  }

  mutate() {
    if (this.element.querySelector('[aria-busy]')) {
      this.element.setAttribute('aria-busy', 'true');
    } else {
      this.element.removeAttribute('aria-busy');
    }
  }

  onFormSubmit(event) {
    // Prevent form submission if the search input is empty
    if (!this.formTarget.q.value.trim()) {
      event.preventDefault();
    }
  }

  #buildSearchUrl(query) {
    const url = new URL(this.searchUrlValue, window.location);
    const trimmed = query?.trim();
    if (trimmed) url.searchParams.set('q', trimmed);
    return url.toString();
  }
}
